module.exports = __webpack_public_path__ + "img/pecans-bg-portrait-992w.2aa22631.jpg";